import axios from 'axios';
import { jwtDecode } from "jwt-decode";
import { useAuthStore } from "../store/useAuthStore";
import { useMessagesStore } from "../store/useMessagesStore";

const { addError } = useMessagesStore.getState();
const { refreshToken, logout, setAccessToken, setRefreshToken, setUser } = useAuthStore.getState();

// Create a separate axios instance for auth operations to avoid circular dependencies
const authApi = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
});

export const apiRotateToken = async () => {
  try {
    const res = await authApi.post('/auth/refresh-token', { refreshToken })
    const { access_token, refresh_token } = res.data;
    try {
      const decoded = jwtDecode(access_token) as any;
      const userRoleType = decoded?.user?.userRoleType;
      if (userRoleType !== 'ADMIN') {
        addError('Invalid user role');
        logout();
        return;
      }
      setUser({
        email: decoded?.user?.email,
        userId: decoded?.sub,
        userRoleId: +decoded?.user?.userRoleId,
        userRoleType
      });
    } catch (error) {
      addError('Unautorized: failed to rotate token');
      logout();
      return;
    }
    setAccessToken(access_token);
    setRefreshToken(refresh_token);
    return {
      accessToken: access_token,
      refreshToken: refresh_token,
    }
  } catch (error) {
    addError('Unautorized: failed to rotate token');
    logout();
    return;
  }
};
